import { _ as __awaiter, a as __generator, b as __assign } from '../_tslib-6fadb982.js';
import BrowserCall from '../browser-call/index.js';
import qs from 'qs';
import '../environment/index.js';
import '../cookie/index.js';
import 'axios';
import token from '../token/index.js';

/*
 * @Author: zhuhd
 * @Date: 2021-05-21 09:55:06
 * @LastEditTime: 2021-08-31 17:37:02
 * @LastEditors: zhuhd
 * @Description: 常量
 * @FilePath: /gtools.gaodunwangxiao.com/src/plugins/src/call/constant.ts
 */
var CLIENT_REQUEST = 'CLIENT_REQUEST';
var HANGUP = 'HANGUP';
var CHANGE_STATUS = 'CHANGE_STATUS';
var CALL = 'CALL';
var ANSWER = 'ANSWER';
var REFRESH_FBOCC_TOKEN = 'REFRESH_FBOCC_TOKEN';
var SET_DEFAULT_INSTANCE = 'SET_DEFAULT_INSTANCE';
var GET_INSTANCE_STATUS = 'GET_INSTANCE_STATUS';
var EMIT_BROADCAST = 'EMIT_BROADCAST';
var SEND_DTMF = 'SEND_DTMF';
var REFRESH_TOKEN = 'REFRESH_TOKEN';
var CLOSE_ALIPLUS = 'CLOSE_ALIPLUS';
var setHeader = function (target, headers) {
  if (!headers) {
    return;
  }
  for (var i in headers) {
    target.setRequestHeader(i, headers[i]);
  }
};
var toData = function (obj) {
  // if (obj == null){
  //     return obj;
  // }
  // var arr = [];
  // for (var i in obj){
  //     var str = i+"="+obj[i];
  //     arr.push(str);
  // }
  // return arr.join("&");
  return qs.stringify(obj, {
    arrayFormat: 'repeat'
  });
};
var httpRequest = function (requestUrl, obj) {
  var env = obj.env,
    type = obj.type,
    headers = obj.headers,
    data = obj.data,
    AppID = obj.AppID;
  return new Promise(function (resolve, reject) {
    return __awaiter(void 0, void 0, void 0, function () {
      var xhr, baseUrl, url, accessToken, getUrl;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            xhr = new XMLHttpRequest();
            baseUrl = "https://" + env + "apigateway.gaodun.com";
            url = "" + baseUrl + requestUrl;
            xhr.onreadystatechange = function () {
              if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
                  var res = JSON.parse(xhr.response);
                  resolve(res);
                } else {
                  reject(xhr.status);
                }
              }
            };
            return [4 /*yield*/, token.getAdmintoken({
              AppID: AppID
            })];
          case 1:
            accessToken = _a.sent();
            getUrl = url;
            if (toData(data) && type === 'get') {
              getUrl = url + '?' + toData(data);
            }
            xhr.open(type, getUrl, true);
            if (accessToken && !accessToken.info) {
              xhr.setRequestHeader('Authentication', "Basic " + accessToken);
            }
            setHeader(xhr, headers);
            if (type === 'post') {
              xhr.send(JSON.stringify(data));
            }
            if (type === 'get') {
              xhr.send();
            }
            return [2 /*return*/];
        }
      });
    });
  });
};
var headers = {
  'Content-Type': 'application/json;charset=utf-8888'
};
// 获取话务配置信息
var getConfig = function (params) {
  return httpRequest("/usopp/api/v1/traffic-channel-configs/get_by_user", __assign({
    headers: headers
  }, params));
};
// 校验手机号
var validPhone = function (params) {
  return httpRequest("/usopp/api/v1/security/phone_check", __assign({
    headers: headers
  }, params));
};
// 电话接通接口，保存通话记录
var saveRecord = function (params) {
  return httpRequest("/usopp/api/v1/call-record/save", __assign({
    headers: headers
  }, params));
};
// 电话挂断接口
var addHangupRecord = function (params) {
  return httpRequest("/usopp/api/v1/call-record/hangup", __assign({
    headers: headers
  }, params));
};
// 呼叫发起 记录
var reportCall = function (params) {
  return httpRequest("/usopp/api/v1/call-record/save-call-log", __assign({
    headers: headers
  }, params));
};

// mutiplePlatform 为false时只实例化默认话务平台
var setChannelConfig = function (agentType, arr, mutiplePlatform) {
  return arr.find(function (item) {
    return item.agentType === agentType && (mutiplePlatform ? true : item.isDefault);
  });
};
var handleConfig = function (agentType, config, mutiplePlatform) {
  var callConfig = {};
  var fboccInfo = {
    config: {
      ctiHost: '',
      ctiWsPort: '',
      host: '',
      pbx: '',
      stun: '',
      wsHost: '',
      wsPort: ''
    },
    token: ''
  };
  var matchChannel = {};
  Object.keys(config).forEach(function (key) {
    switch (key) {
      case 'aliConfigs':
        matchChannel = setChannelConfig(agentType, config[key], mutiplePlatform);
        matchChannel && (callConfig['aliyun'] = matchChannel);
        break;
      case 'fboccConfigs':
        matchChannel = setChannelConfig(agentType, config[key], mutiplePlatform);
        if (matchChannel) {
          callConfig['fbocc'] = matchChannel;
          var ctiHost = matchChannel.ctiHost,
            ctiWsPort = matchChannel.ctiWsPort,
            host = matchChannel.host,
            pbx = matchChannel.pbx,
            stun = matchChannel.stun,
            wsHost = matchChannel.wsHost,
            wsPort = matchChannel.wsPort,
            token = matchChannel.token;
          fboccInfo = {
            config: {
              ctiHost: ctiHost,
              ctiWsPort: ctiWsPort,
              host: host,
              pbx: pbx,
              stun: stun,
              wsHost: wsHost,
              wsPort: wsPort
            },
            token: token
          };
        }
        break;
      case 'tengXunConfig':
        matchChannel = setChannelConfig(agentType, config[key], mutiplePlatform);
        matchChannel && (callConfig['tengxun'] = matchChannel);
        break;
      case 'ali2Configs':
        matchChannel = setChannelConfig(agentType, config[key], mutiplePlatform);
        matchChannel && (callConfig['aliyunPlus'] = matchChannel);
        break;
      case 'tianRunConfigs':
        matchChannel = setChannelConfig(agentType, config[key], mutiplePlatform);
        matchChannel && (callConfig['tianrun'] = matchChannel);
        break;
    }
  });
  return {
    callConfig: callConfig,
    fboccInfo: fboccInfo
  };
};
/**
 *  获取话务配置信息
 *   获取话务配置信息 -- 根据agentType 筛选 并格式化
 *   获取关联的 fbocc / ali 相关信息
 **/
var initTrafficInfo = function (userId, AppID, agentType, env, mutiplePlatform) {
  return new Promise(function (resolve, reject) {
    return __awaiter(void 0, void 0, void 0, function () {
      var res, result, callConfig;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, getConfig({
              type: 'get',
              env: env,
              AppID: AppID,
              data: {
                userId: userId
              }
            })];
          case 1:
            res = _a.sent();
            if (res.status === 0) {
              result = handleConfig(agentType, res.result, mutiplePlatform);
              callConfig = result.callConfig;
              if (Object.keys(callConfig).length > 0) {
                resolve(result);
              } else {
                reject({
                  msg: '未配置对应座席话务，请联系技术客服',
                  type: 1002
                });
              }
              // resolve(result)
            } else {
              reject({
                msg: res.info,
                type: 1001
              });
            }
            return [2 /*return*/];
        }
      });
    });
  });
};

/*
 * @Author: zhuhd
 * @Date: 2021-05-21 09:50:18
 * @LastEditTime: 2021-12-20 13:20:26
 * @LastEditors: Please set LastEditors
 * @Description:高顿呼叫平台对接socket sdk
 */
// OB   "OB"
// TIAN_RUN   "天润云",
// SEVEN_MOOR  "七陌"
var platformEnum = {
  aliyun: 'ALI',
  fbocc: 'FBOCC',
  tengxun: 'QI_DIAN',
  tianrun: 'TIAN_RUN',
  aliyunPlus: 'ALI_2'
};
var CallSdk = /** @class */function () {
  function CallSdk(callProps) {
    var _a;
    this.socketStatus = 'disconnect';
    this.browserInstance = null;
    this.platformStatus = {}; // 话务平台状态
    this.otherOriginClient = false;
    this.paramsSocket = undefined;
    this.useBrowser = true; // 使用浏览器通话
    this.connectedCall = false; // 接通通话
    this.sdkClient = localStorage.getItem('traffic_client') || '';
    this.config = this.recordMiddleware(callProps.config, callProps.normalize || false);
    this.environment = callProps.environment;
    callProps.socketIo && (this.paramsSocket = callProps.socketIo);
    this.normalize = callProps.normalize || false;
    this.mutiplePlatform = callProps.mutiplePlatform || false;
    this.params = callProps.params;
    this.otherOriginClient = (_a = callProps.otherOriginClient) !== null && _a !== void 0 ? _a : false;
    // this.initSocket(callProps.params);
    this.useBrowser = callProps.useBrowser;
    this.normalizeTrafficInfo(callProps.useBrowser);
    this.initListener();
  }
  CallSdk.prototype.initListener = function () {
    var _this = this;
    window.addEventListener('storage', function () {
      var traffic_client = localStorage.getItem('traffic_client');
      if (_this.sdkClient !== traffic_client && traffic_client === 'client') {
        _this.logoutAliPlus();
        _this.sdkClient = traffic_client;
      }
    });
  };
  // 使用客户端时先检查 socket链接状态
  CallSdk.prototype.checkSocketStatus = function () {
    if (this.socketStatus === 'disconnect') {
      this.config.onWarn('客户端未开启，请检查客户端');
    }
    return this.socketStatus !== 'disconnect';
  };
  // 状态改变同步
  CallSdk.prototype.handleStatus = function (status, platform) {
    var platformName = platform !== null && platform !== void 0 ? platform : 'default';
    this.platformStatus[platformName] = status;
  };
  // 微前端中 使用客户端场景 获取话务状态  -- -- 不推荐使用方法
  CallSdk.prototype.getPlatformStatus = function (platform) {
    return platform && this.platformStatus[platform] ? this.platformStatus[platform] : this.platformStatus['default'] || 0;
  };
  // 是否通话状态
  CallSdk.prototype.isCalling = function () {
    var talkStatusList = [6, 8, 10];
    var statusList = Object.values(this.platformStatus);
    return statusList.find(function (item) {
      return talkStatusList.includes(Number(item));
    });
  };
  // 接通通话 和 结束通话 保存信息到后端
  CallSdk.prototype.recordMiddleware = function (config, normalize) {
    var _this = this;
    var resetConfig = Object.assign({}, config);
    resetConfig.onStatusChange = function (status, platform) {
      _this.handleStatus(status, platform);
      config.onStatusChange(status, platform);
    };
    // 使用标准话务时 新增保存 接通/挂断通话
    if (!normalize) {
      resetConfig.addRecord = function (params, type, platform) {
        // @ts-ignore
        _this.recordParams = params;
        var callExtStr = platform === 'tengxun' ? 'kfext' : 'callExt';
        // @ts-ignore
        var callExt = _this.params.callConfig[platform][callExtStr] || '';
        config.addRecord(__assign(__assign({}, params), {
          callExt: callExt
        }), type, platform);
      };
      return resetConfig;
    }
    resetConfig.addRecord = function (params, type, platform) {
      // @ts-ignore
      _this.recordParams = params;
      var callExtStr = platform === 'tengxun' ? 'kfext' : 'callExt';
      // @ts-ignore
      var callExt = _this.params.callConfig[platform][callExtStr] || '';
      config.addRecord(__assign(__assign({}, params), {
        callExt: callExt
      }), type, platform);
    };
    resetConfig.onCall = function (platform) {
      _this.addCallRecord();
      config.onCall(platform);
    };
    resetConfig.onHangup = function (platform) {
      _this.connectedCall && platform !== 'aliyun' && _this.addHangUpRecord(platformEnum[platform]);
      config.onHangup(platform);
    };
    // 阿里云释放通话 1.0
    resetConfig.onReleaseCall = function (data, platform) {
      var _a;
      _this.connectedCall && platform !== 'aliyunPlus' && _this.addHangUpRecord(platformEnum['aliyun'], (_a = data === null || data === void 0 ? void 0 : data.privateData) === null || _a === void 0 ? void 0 : _a.acid);
      config.onReleaseCall && config.onReleaseCall(data, platform);
    };
    return resetConfig;
  };
  // 添加接通记录
  CallSdk.prototype.addCallRecord = function () {
    this.connectedCall = true;
    var _a = this.recordParams,
      FromNo = _a.FromNo,
      ToNo = _a.ToNo,
      RecordId = _a.RecordId,
      platform = _a.platform,
      phoneType = _a.phoneType;
    var _b = this.params.userInfo,
      userId = _b.userId,
      appId = _b.appId;
    var callExt = platform === 'tengxun' ? 'kfext' : 'callExt';
    var params = {
      answerNo: ToNo,
      appId: appId,
      callCenterType: platformEnum[platform],
      // @ts-ignore
      callExt: this.params.callConfig[platform][callExt] || '',
      callNo: FromNo,
      callType: phoneType === 2 ? 0 : 1,
      externalRecordId: RecordId,
      userId: userId
    };
    saveRecord({
      type: 'post',
      env: this.environment,
      AppID: appId,
      data: params
    });
  };
  // 添加挂断电话记录
  CallSdk.prototype.addHangUpRecord = function (platformType, acid) {
    var _this = this;
    if (acid === void 0) {
      acid = '';
    }
    var _a = this.recordParams,
      FromNo = _a.FromNo,
      ToNo = _a.ToNo,
      RecordId = _a.RecordId;
    var _b = this.params.userInfo,
      userId = _b.userId,
      appId = _b.appId;
    var params = {
      acid: acid,
      called: ToNo,
      caller: FromNo,
      connId: RecordId,
      callCenterType: platformType,
      loginUserId: userId
    };
    addHangupRecord({
      type: 'post',
      env: this.environment,
      AppID: appId,
      data: params
    }).then(function (res) {
      _this.recordParams = undefined;
      _this.connectedCall = false;
    });
  };
  // 不同话务场景处理
  CallSdk.prototype.normalizeTrafficInfo = function (useBrowser) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, userId, agentType, appId, res, error_1;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.params.userInfo, userId = _a.userId, agentType = _a.agentType, appId = _a.appId;
            if (!this.normalize) return [3 /*break*/, 4];
            _b.label = 1;
          case 1:
            _b.trys.push([1, 3,, 4]);
            return [4 /*yield*/, initTrafficInfo(userId, appId, agentType, this.environment, this.mutiplePlatform)];
          case 2:
            res = _b.sent();
            this.params.callConfig = res.callConfig;
            this.params.fboccInfo = res.fboccInfo;
            return [3 /*break*/, 4];
          case 3:
            error_1 = _b.sent();
            this.config.onWarn(error_1.msg, error_1.type);
            return [2 /*return*/, false];
          case 4:
            this.switchPlatform(useBrowser);
            return [2 /*return*/];
        }
      });
    });
  };
  CallSdk.prototype.initSocket = function (params) {
    var _this = this;
    if (this.paramsSocket) {
      this.socketIo = this.paramsSocket;
      this.initConnect(params);
    } else {
      if (!this.socketIo) {
        var script = document.createElement('script');
        script.id = 'gaodunCallSocket';
        script.type = 'text/javascript';
        script.src = "https://s.gaodun.com/web/scripts/widget/socket.io.min.js?v=" + Date.now();
        script.onload = function () {
          // @ts-ignore
          _this.socketIo = io;
          _this.initConnect(params);
        };
        try {
          document.getElementsByTagName('head')[0].appendChild(script);
        } catch (error) {}
      } else {
        this.initConnect(params);
      }
    }
    setTimeout(function () {
      if (_this.socketStatus !== 'connect') {
        window.open('gaoduncall://');
      }
    }, 200);
  };
  CallSdk.prototype.initConnect = function (params) {
    var _this = this;
    this.teptSocket = this.socketIo("http://localhost:4074", {
      path: '/call',
      reconnection: true,
      withCredentials: true,
      query: {
        callConfig: JSON.stringify(params.callConfig),
        userInfo: JSON.stringify(params.userInfo),
        fboccInfo: JSON.stringify(params.fboccInfo),
        environment: this.environment,
        otherOriginClient: this.otherOriginClient
      }
    });
    // listeners
    this.teptSocket.on('connect', function () {
      // this.config.onConnect('application');  客户端会发onConnect消息
      _this.handleApplicationConnected();
    });
    this.teptSocket.on('disconnect', function (e) {
      console.log('socket disconnect', e);
      _this.socketStatus = 'disconnect';
      _this.config.onDisconnect && _this.config.onDisconnect();
      // 客户端断开链接 状态推送未签入
      _this.config.onStatusChange(1);
    });
    this.teptSocket.on('message', function (data) {
      _this.handleMessage(data);
    });
  };
  /**
   *
   * @param {*} message Data
   * type: status / callback
   * params:  status / callBackType
   * status: onStatusChange, // (status) 实例状态改变  1 签出 2 签入 3 空闲 4置忙 6振铃  8拨号 9 呼入通话 10 呼出通话
   * config:  callBackType: onCall, // 通话; onCallUp, // 拨号中, addRecord, // 添加通话记录 onHangup,  // 挂断
   * onShowCommingCall, // 来电通知; onWarn,  // 警告 提示  onFobccTokenOutDate // fbocc token 过期
   */
  CallSdk.prototype.handleMessage = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    switch (data.type) {
      case 'status':
        // console.log('sdk status change', data, data.params?.status);
        ((_a = data.params) === null || _a === void 0 ? void 0 : _a.status) && this.config.onStatusChange((_b = data.params) === null || _b === void 0 ? void 0 : _b.status, (_c = data.params) === null || _c === void 0 ? void 0 : _c.platform);
        break;
      case 'callback':
        console.log('callback', data);
        if (((_d = data.params) === null || _d === void 0 ? void 0 : _d.callBackType) && data.params.callBackType === 'onRegistrationFailed') {
          this.config.onRegistrationFailed((_e = data.params) === null || _e === void 0 ? void 0 : _e.content.platform, (_f = data.params) === null || _f === void 0 ? void 0 : _f.content.msg);
        } else if (((_g = data.params) === null || _g === void 0 ? void 0 : _g.callBackType) && data.params.callBackType === 'onReleaseCall') {
          // @ts-ignore
          this.config.onReleaseCall((_h = data.params) === null || _h === void 0 ? void 0 : _h.content, (_j = data.params) === null || _j === void 0 ? void 0 : _j.content.platform);
        } else {
          ((_k = data.params) === null || _k === void 0 ? void 0 : _k.callBackType) && this.config[(_l = data.params) === null || _l === void 0 ? void 0 : _l.callBackType] &&
          // @ts-ignore
          this.config[(_m = data.params) === null || _m === void 0 ? void 0 : _m.callBackType]((_o = data.params) === null || _o === void 0 ? void 0 : _o.content);
        }
        break;
      case 'record':
        // console.log('addRecord data', data);
        this.config.addRecord((_p = data.params) === null || _p === void 0 ? void 0 : _p.content.params, (_q = data.params) === null || _q === void 0 ? void 0 : _q.content.type, (_r = data.params) === null || _r === void 0 ? void 0 : _r.content.platform);
        break;
      case 'onClose':
        this.config.onClose && this.config.onClose((_s = data.params) === null || _s === void 0 ? void 0 : _s.content.type, (_t = data.params) === null || _t === void 0 ? void 0 : _t.content.platform, (_u = data.params) === null || _u === void 0 ? void 0 : _u.content.msg);
        this.config.onStatusChange(14, (_v = data.params) === null || _v === void 0 ? void 0 : _v.content.platform);
        break;
      case 'onCallFail':
        this.config.onCallFail && this.config.onCallFail((_w = data.params) === null || _w === void 0 ? void 0 : _w.content.msg, (_x = data.params) === null || _x === void 0 ? void 0 : _x.content.platform);
        break;
    }
  };
  // aliplus logout
  CallSdk.prototype.logoutAliPlus = function () {
    this.browserInstance && this.browserInstance.logoutAliPlus();
  };
  CallSdk.prototype.logoutAliPlusClient = function () {
    this.teptSocket.emit(CLIENT_REQUEST, {
      messageType: CLOSE_ALIPLUS
    });
  };
  // 签入
  CallSdk.prototype.handleLogin = function () {
    this.switchStatus(1);
  };
  // 签出
  CallSdk.prototype.handlLogout = function () {
    this.switchStatus(2);
  };
  // 置忙
  CallSdk.prototype.handleBusy = function () {
    this.switchStatus(3);
  };
  // 置闲
  CallSdk.prototype.handleFree = function () {
    this.switchStatus(4);
  };
  // 话务状态更改   节流?
  CallSdk.prototype.switchStatus = function (status) {
    if (this.useBrowser) {
      this.browserInstance && this.browserInstance.switchStatus(status);
    } else {
      if (!this.checkSocketStatus()) return;
      this.teptSocket.emit(CLIENT_REQUEST, {
        messageType: CHANGE_STATUS,
        status: status
      });
    }
  };
  // 挂断
  CallSdk.prototype.hangup = function () {
    if (this.useBrowser) {
      this.browserInstance && this.browserInstance.hangup();
    } else {
      if (this.teptSocket) {
        if (!this.checkSocketStatus()) return;
        this.teptSocket.emit(CLIENT_REQUEST, {
          messageType: HANGUP
        });
      }
    }
  };
  CallSdk.prototype.reportBeforeCall = function (phone, plat) {
    var platform = plat;
    var callExtStr = platform === 'tengxun' ? 'kfext' : 'callExt';
    // @ts-ignore
    var callExt = platform ? this.params.callConfig[platform][callExtStr] || '' : '';
    var typse = {
      tengxun: 4,
      aliyunPlus: 2,
      aliyun: 2,
      fbocc: 6,
      tianrun: 3
    };
    var _a = this.params.userInfo,
      userId = _a.userId,
      appId = _a.appId;
    var params = {
      userId: userId,
      callCenterType: platform ? typse[platform] : '',
      callExt: callExt,
      callId: '',
      answerNo: phone,
      remark: "\u6D4F\u89C8\u5668\u70B9\u51FB\u547C\u53EB--" + (platform || '') + "--" + Date.now()
    };
    reportCall({
      type: 'post',
      env: this.environment,
      AppID: appId,
      data: params
    });
  };
  // 呼叫
  CallSdk.prototype.call = function (phone, platform) {
    var _this = this;
    this.reportBeforeCall(phone, platform);
    if (this.normalize) {
      validPhone({
        type: 'get',
        env: this.environment,
        AppID: this.params.userInfo.appId,
        data: {
          mobile: phone,
          appId: this.params.userInfo.appId
        }
      }).then(function (res) {
        if (res.result) {
          if (_this.useBrowser) {
            _this.browserInstance && _this.browserInstance.call(phone, platform);
          } else {
            if (!_this.checkSocketStatus()) return;
            _this.teptSocket.emit(CLIENT_REQUEST, {
              messageType: CALL,
              callee: phone,
              platform: platform
            });
          }
        } else {
          _this.config.onWarn(res.info || '拨号失败，请检查号码格式');
        }
      })["catch"](function (err) {
        _this.config.onWarn('拨号失败，请检查号码格式');
      });
    } else {
      if (this.useBrowser) {
        this.browserInstance && this.browserInstance.call(phone, platform);
      } else {
        if (!this.checkSocketStatus()) return;
        this.teptSocket.emit(CLIENT_REQUEST, {
          messageType: CALL,
          callee: phone,
          platform: platform
        });
      }
    }
  };
  // 应答
  CallSdk.prototype.answer = function () {
    if (this.useBrowser) {
      this.browserInstance && this.browserInstance.handleAnswer();
    } else {
      if (!this.checkSocketStatus()) return;
      this.teptSocket.emit(CLIENT_REQUEST, {
        messageType: ANSWER
      });
    }
  };
  // 二次拨号
  CallSdk.prototype.sendDtmf = function (code, platform) {
    if (this.useBrowser) {
      this.browserInstance && this.browserInstance.sendDtmf(code, platform);
    } else {
      if (!this.checkSocketStatus()) return;
      this.teptSocket.emit(CLIENT_REQUEST, {
        messageType: SEND_DTMF,
        code: code,
        platform: platform
      });
    }
  };
  // 刷新 fbocc token
  CallSdk.prototype.resetFboccToken = function (token) {
    if (this.useBrowser) {
      this.browserInstance.resetFboccToken(token);
    } else {
      if (!this.checkSocketStatus()) return;
      this.teptSocket.emit(CLIENT_REQUEST, {
        messageType: REFRESH_FBOCC_TOKEN,
        token: token
      });
    }
  };
  // 刷新token fbocc || qidian...
  CallSdk.prototype.resetToken = function (token, platform) {
    if (this.useBrowser) {
      this.browserInstance.resetToken(token, platform);
    } else {
      if (!this.checkSocketStatus()) return;
      this.teptSocket.emit(CLIENT_REQUEST, {
        messageType: REFRESH_TOKEN,
        token: token,
        platform: platform
      });
    }
  };
  // 设置默认通话平台
  CallSdk.prototype.setDefaultInstance = function (platform) {
    if (this.useBrowser) {
      this.browserInstance && this.browserInstance.setDefaultInstance(platform);
    } else {
      if (!this.checkSocketStatus()) return;
      this.teptSocket.emit(CLIENT_REQUEST, {
        messageType: SET_DEFAULT_INSTANCE,
        platform: platform
      });
    }
  };
  // 获取通话平台状态  没参数 取默认平台   平台为未配置 返回 0
  CallSdk.prototype.getInstanceStatus = function (platform) {
    if (this.useBrowser) {
      this.browserInstance && this.browserInstance.getInstanceStatus(platform);
    } else {
      if (!this.checkSocketStatus()) return;
      this.teptSocket.emit(CLIENT_REQUEST, {
        messageType: GET_INSTANCE_STATUS,
        platform: platform
      });
    }
  };
  // 桌面端 链接成功
  CallSdk.prototype.handleApplicationConnected = function () {
    this.browserInstance && this.browserInstance.destroy();
    this.browserInstance = null;
    this.useBrowser = false;
    this.socketStatus = 'connect';
  };
  // 设置config
  CallSdk.prototype.setConfig = function (config, userInfo) {
    if (userInfo) {
      this.normalize = userInfo.normalize || false;
      this.params.userInfo.appId = userInfo.appId;
      this.params.userInfo.agentType = userInfo.agentType;
    }
    var newConfig = this.recordMiddleware(Object.assign({}, this.config, config), this.normalize);
    this.config = newConfig;
    if (this.useBrowser && this.browserInstance) {
      this.browserInstance.setConfig(newConfig);
    }
  };
  // 切换通话平台
  CallSdk.prototype.switchPlatform = function (use) {
    // 切换平台 或者 刷新 先挂断当前通话（如存在）
    // this.hangup();
    if (this.isCalling()) {
      this.config.onWarn('请不要在通话过程中切换浏览器或客户端');
      return;
    }
    if (use && this.teptSocket) {
      this.logoutAliPlusClient();
    }
    this.teptSocket && this.teptSocket.destroy();
    if (use) {
      try {
        localStorage.setItem('traffic_client', 'browser');
        this.sdkClient = 'browser';
        this.browserInstance && this.logoutAliPlus();
        this.useBrowser = use;
        this.browserInstance && this.browserInstance.destroy();
        this.browserInstance = new BrowserCall({
          params: this.params,
          config: this.config,
          environment: this.environment,
          otherOriginClient: this.otherOriginClient
        });
        this.config.onConnect('browser');
      } catch (error) {
        console.log('error', error);
      }
    } else {
      localStorage.setItem('traffic_client', 'client');
      this.sdkClient = 'client';
      this.socketStatus = 'disconnect';
      this.initSocket(this.params);
    }
  };
  CallSdk.prototype.destroy = function () {
    this.teptSocket && this.teptSocket.destroy();
    this.browserInstance && this.browserInstance.destroy();
    this.browserInstance = null;
  };
  // 通过桌面端 消息广播
  CallSdk.prototype.emitBroadcast = function (params) {
    if (this.useBrowser) {
      this.config.onBroadcast && this.config.onBroadcast(params);
    } else {
      if (!this.checkSocketStatus()) return;
      this.teptSocket.emit(CLIENT_REQUEST, {
        messageType: EMIT_BROADCAST,
        params: params
      });
    }
  };
  CallSdk.prototype.getDeviceType = function () {
    var device = window.navigator.userAgent.toLocaleLowerCase();
    if (device.includes('mac')) {
      return 'mac';
    }
    if (device.includes('win')) {
      return 'win';
    }
    return '';
  };
  CallSdk.prototype.getDownloadUrl = function () {
    var _this = this;
    return new Promise(function (resolve, reject) {
      var device = _this.getDeviceType();
      if (!device) resolve('');
      var xhr = new XMLHttpRequest();
      var macUrl = 'https://gd-file.gaodun.com/gd-call/latest-mac.yml';
      var winUrl = 'https://gd-file.gaodun.com/gd-call/latest.yml';
      var url = device === 'mac' ? macUrl : winUrl;
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status >= 200 && xhr.status < 300 || xhr.status == 304) {
            // @ts-ignore
            var resultStr = xhr.responseText;
            var reg = /version:(.*?)(?=\nfiles)/g;
            var arr = resultStr.match(reg) || [];
            if (arr.length) {
              var clientVersion = arr[0].replace('version: ', '');
              if (device === 'mac') {
                resolve("https://gd-file.gaodun.com/gd-call/mac/" + clientVersion + "/gaoduncall-" + clientVersion + ".dmg");
              } else {
                resolve("https://gd-file.gaodun.com/gd-call/windows/" + clientVersion + "/gaoduncall-" + clientVersion + ".exe");
              }
            }
          }
        }
      };
      xhr.open('get', url, true);
      xhr.send();
    });
  };
  return CallSdk;
}();
export default CallSdk;